/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AppRouteImport } from './routes/app'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as ExclusaoDeDadosRouteImport } from './routes/exclusao-de-dados'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminCuponsRouteImport } from './routes/admin/cupons'
import { Route as AdminPlanosRouteImport } from './routes/admin/planos'
import { Route as AdminWorkspacesRouteImport } from './routes/admin/workspaces'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppWorkspaceIdRouteImport } from './routes/app/$workspaceId'
import { Route as AppContaRouteImport } from './routes/app/conta'
import { Route as AppNovoWorkspaceRouteImport } from './routes/app/novo-workspace'
import { Route as ConviteTokenRouteImport } from './routes/convite.$token'
import { Route as RelatorioTokenRouteImport } from './routes/relatorio.$token'
import { Route as AdminWorkspacesIdRouteImport } from './routes/admin/workspaces_.$id'
import { Route as AppWorkspaceIdIndexRouteImport } from './routes/app/$workspaceId/index'
import { Route as AppWorkspaceIdAssistenteRouteImport } from './routes/app/$workspaceId/assistente'
import { Route as AppWorkspaceIdAuditoriaRouteImport } from './routes/app/$workspaceId/auditoria'
import { Route as AppWorkspaceIdBusinessManagersRouteImport } from './routes/app/$workspaceId/business-managers'
import { Route as AppWorkspaceIdCampanhasRouteImport } from './routes/app/$workspaceId/campanhas'
import { Route as AppWorkspaceIdClientesRouteImport } from './routes/app/$workspaceId/clientes'
import { Route as AppWorkspaceIdCobrancaRouteImport } from './routes/app/$workspaceId/cobranca'
import { Route as AppWorkspaceIdConfiguracoesRouteImport } from './routes/app/$workspaceId/configuracoes'
import { Route as AppWorkspaceIdContasDeAnuncioRouteImport } from './routes/app/$workspaceId/contas-de-anuncio'
import { Route as AppWorkspaceIdCriativosRouteImport } from './routes/app/$workspaceId/criativos'
import { Route as AppWorkspaceIdIaRouteImport } from './routes/app/$workspaceId/ia'
import { Route as AppWorkspaceIdImplantacaoRouteImport } from './routes/app/$workspaceId/implantacao'
import { Route as AppWorkspaceIdIntegracoesRouteImport } from './routes/app/$workspaceId/integracoes'
import { Route as AppWorkspaceIdLeadsRouteImport } from './routes/app/$workspaceId/leads'
import { Route as AppWorkspaceIdMembrosRouteImport } from './routes/app/$workspaceId/membros'
import { Route as AppWorkspaceIdNotificacoesRouteImport } from './routes/app/$workspaceId/notificacoes'
import { Route as AppWorkspaceIdPaginasEPixelsRouteImport } from './routes/app/$workspaceId/paginas-e-pixels'
import { Route as AppWorkspaceIdPublicosRouteImport } from './routes/app/$workspaceId/publicos'
import { Route as AppWorkspaceIdRegrasRouteImport } from './routes/app/$workspaceId/regras'
import { Route as AppWorkspaceIdRelatoriosRouteImport } from './routes/app/$workspaceId/relatorios'
import { Route as CobrancaSimuladoSessionIdRouteImport } from './routes/cobranca.simulado.$sessionId'
import { Route as AppWorkspaceIdAssistenteDraftIdRouteImport } from './routes/app/$workspaceId/assistente_.$draftId'
import { Route as AppWorkspaceIdBusinessManagersBusinessIdRouteImport } from './routes/app/$workspaceId/business-managers_.$businessId'
import { Route as AppWorkspaceIdImplantacaoImplantationIdRouteImport } from './routes/app/$workspaceId/implantacao_.$implantationId'
import { Route as AppWorkspaceIdRegrasRuleIdRouteImport } from './routes/app/$workspaceId/regras_.$ruleId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const CadastroRoute = CadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const ExclusaoDeDadosRoute = ExclusaoDeDadosRouteImport.update({
  id: '/exclusao-de-dados',
  path: '/exclusao-de-dados',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCuponsRoute = AdminCuponsRouteImport.update({
  id: '/cupons',
  path: '/cupons',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlanosRoute = AdminPlanosRouteImport.update({
  id: '/planos',
  path: '/planos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWorkspacesRoute = AdminWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AdminRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkspaceIdRoute = AppWorkspaceIdRouteImport.update({
  id: '/$workspaceId',
  path: '/$workspaceId',
  getParentRoute: () => AppRoute,
} as any)
const AppContaRoute = AppContaRouteImport.update({
  id: '/conta',
  path: '/conta',
  getParentRoute: () => AppRoute,
} as any)
const AppNovoWorkspaceRoute = AppNovoWorkspaceRouteImport.update({
  id: '/novo-workspace',
  path: '/novo-workspace',
  getParentRoute: () => AppRoute,
} as any)
const ConviteTokenRoute = ConviteTokenRouteImport.update({
  id: '/convite/$token',
  path: '/convite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const RelatorioTokenRoute = RelatorioTokenRouteImport.update({
  id: '/relatorio/$token',
  path: '/relatorio/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkspacesIdRoute = AdminWorkspacesIdRouteImport.update({
  id: '/workspaces_/$id',
  path: '/workspaces/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AppWorkspaceIdIndexRoute = AppWorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdAssistenteRoute =
  AppWorkspaceIdAssistenteRouteImport.update({
    id: '/assistente',
    path: '/assistente',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdAuditoriaRoute = AppWorkspaceIdAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdBusinessManagersRoute =
  AppWorkspaceIdBusinessManagersRouteImport.update({
    id: '/business-managers',
    path: '/business-managers',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdCampanhasRoute = AppWorkspaceIdCampanhasRouteImport.update({
  id: '/campanhas',
  path: '/campanhas',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdClientesRoute = AppWorkspaceIdClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdCobrancaRoute = AppWorkspaceIdCobrancaRouteImport.update({
  id: '/cobranca',
  path: '/cobranca',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdConfiguracoesRoute =
  AppWorkspaceIdConfiguracoesRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdContasDeAnuncioRoute =
  AppWorkspaceIdContasDeAnuncioRouteImport.update({
    id: '/contas-de-anuncio',
    path: '/contas-de-anuncio',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdCriativosRoute = AppWorkspaceIdCriativosRouteImport.update({
  id: '/criativos',
  path: '/criativos',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdIaRoute = AppWorkspaceIdIaRouteImport.update({
  id: '/ia',
  path: '/ia',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdImplantacaoRoute =
  AppWorkspaceIdImplantacaoRouteImport.update({
    id: '/implantacao',
    path: '/implantacao',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdIntegracoesRoute =
  AppWorkspaceIdIntegracoesRouteImport.update({
    id: '/integracoes',
    path: '/integracoes',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdLeadsRoute = AppWorkspaceIdLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdMembrosRoute = AppWorkspaceIdMembrosRouteImport.update({
  id: '/membros',
  path: '/membros',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdNotificacoesRoute =
  AppWorkspaceIdNotificacoesRouteImport.update({
    id: '/notificacoes',
    path: '/notificacoes',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdPaginasEPixelsRoute =
  AppWorkspaceIdPaginasEPixelsRouteImport.update({
    id: '/paginas-e-pixels',
    path: '/paginas-e-pixels',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdPublicosRoute = AppWorkspaceIdPublicosRouteImport.update({
  id: '/publicos',
  path: '/publicos',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdRegrasRoute = AppWorkspaceIdRegrasRouteImport.update({
  id: '/regras',
  path: '/regras',
  getParentRoute: () => AppWorkspaceIdRoute,
} as any)
const AppWorkspaceIdRelatoriosRoute =
  AppWorkspaceIdRelatoriosRouteImport.update({
    id: '/relatorios',
    path: '/relatorios',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const CobrancaSimuladoSessionIdRoute =
  CobrancaSimuladoSessionIdRouteImport.update({
    id: '/cobranca/simulado/$sessionId',
    path: '/cobranca/simulado/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppWorkspaceIdAssistenteDraftIdRoute =
  AppWorkspaceIdAssistenteDraftIdRouteImport.update({
    id: '/assistente_/$draftId',
    path: '/assistente/$draftId',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdBusinessManagersBusinessIdRoute =
  AppWorkspaceIdBusinessManagersBusinessIdRouteImport.update({
    id: '/business-managers_/$businessId',
    path: '/business-managers/$businessId',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdImplantacaoImplantationIdRoute =
  AppWorkspaceIdImplantacaoImplantationIdRouteImport.update({
    id: '/implantacao_/$implantationId',
    path: '/implantacao/$implantationId',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)
const AppWorkspaceIdRegrasRuleIdRoute =
  AppWorkspaceIdRegrasRuleIdRouteImport.update({
    id: '/regras_/$ruleId',
    path: '/regras/$ruleId',
    getParentRoute: () => AppWorkspaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/cadastro': typeof CadastroRoute
  '/entrar': typeof EntrarRoute
  '/exclusao-de-dados': typeof ExclusaoDeDadosRoute
  '/privacidade': typeof PrivacidadeRoute
  '/termos': typeof TermosRoute
  '/admin/cupons': typeof AdminCuponsRoute
  '/admin/planos': typeof AdminPlanosRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/app/$workspaceId': typeof AppWorkspaceIdRouteWithChildren
  '/app/conta': typeof AppContaRoute
  '/app/novo-workspace': typeof AppNovoWorkspaceRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/relatorio/$token': typeof RelatorioTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/workspaces/$id': typeof AdminWorkspacesIdRoute
  '/app/$workspaceId/assistente': typeof AppWorkspaceIdAssistenteRoute
  '/app/$workspaceId/auditoria': typeof AppWorkspaceIdAuditoriaRoute
  '/app/$workspaceId/business-managers': typeof AppWorkspaceIdBusinessManagersRoute
  '/app/$workspaceId/campanhas': typeof AppWorkspaceIdCampanhasRoute
  '/app/$workspaceId/clientes': typeof AppWorkspaceIdClientesRoute
  '/app/$workspaceId/cobranca': typeof AppWorkspaceIdCobrancaRoute
  '/app/$workspaceId/configuracoes': typeof AppWorkspaceIdConfiguracoesRoute
  '/app/$workspaceId/contas-de-anuncio': typeof AppWorkspaceIdContasDeAnuncioRoute
  '/app/$workspaceId/criativos': typeof AppWorkspaceIdCriativosRoute
  '/app/$workspaceId/ia': typeof AppWorkspaceIdIaRoute
  '/app/$workspaceId/implantacao': typeof AppWorkspaceIdImplantacaoRoute
  '/app/$workspaceId/integracoes': typeof AppWorkspaceIdIntegracoesRoute
  '/app/$workspaceId/leads': typeof AppWorkspaceIdLeadsRoute
  '/app/$workspaceId/membros': typeof AppWorkspaceIdMembrosRoute
  '/app/$workspaceId/notificacoes': typeof AppWorkspaceIdNotificacoesRoute
  '/app/$workspaceId/paginas-e-pixels': typeof AppWorkspaceIdPaginasEPixelsRoute
  '/app/$workspaceId/publicos': typeof AppWorkspaceIdPublicosRoute
  '/app/$workspaceId/regras': typeof AppWorkspaceIdRegrasRoute
  '/app/$workspaceId/relatorios': typeof AppWorkspaceIdRelatoriosRoute
  '/cobranca/simulado/$sessionId': typeof CobrancaSimuladoSessionIdRoute
  '/app/$workspaceId/': typeof AppWorkspaceIdIndexRoute
  '/app/$workspaceId/assistente/$draftId': typeof AppWorkspaceIdAssistenteDraftIdRoute
  '/app/$workspaceId/business-managers/$businessId': typeof AppWorkspaceIdBusinessManagersBusinessIdRoute
  '/app/$workspaceId/implantacao/$implantationId': typeof AppWorkspaceIdImplantacaoImplantationIdRoute
  '/app/$workspaceId/regras/$ruleId': typeof AppWorkspaceIdRegrasRuleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cadastro': typeof CadastroRoute
  '/entrar': typeof EntrarRoute
  '/exclusao-de-dados': typeof ExclusaoDeDadosRoute
  '/privacidade': typeof PrivacidadeRoute
  '/termos': typeof TermosRoute
  '/admin/cupons': typeof AdminCuponsRoute
  '/admin/planos': typeof AdminPlanosRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/app/conta': typeof AppContaRoute
  '/app/novo-workspace': typeof AppNovoWorkspaceRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/relatorio/$token': typeof RelatorioTokenRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/admin/workspaces/$id': typeof AdminWorkspacesIdRoute
  '/app/$workspaceId/assistente': typeof AppWorkspaceIdAssistenteRoute
  '/app/$workspaceId/auditoria': typeof AppWorkspaceIdAuditoriaRoute
  '/app/$workspaceId/business-managers': typeof AppWorkspaceIdBusinessManagersRoute
  '/app/$workspaceId/campanhas': typeof AppWorkspaceIdCampanhasRoute
  '/app/$workspaceId/clientes': typeof AppWorkspaceIdClientesRoute
  '/app/$workspaceId/cobranca': typeof AppWorkspaceIdCobrancaRoute
  '/app/$workspaceId/configuracoes': typeof AppWorkspaceIdConfiguracoesRoute
  '/app/$workspaceId/contas-de-anuncio': typeof AppWorkspaceIdContasDeAnuncioRoute
  '/app/$workspaceId/criativos': typeof AppWorkspaceIdCriativosRoute
  '/app/$workspaceId/ia': typeof AppWorkspaceIdIaRoute
  '/app/$workspaceId/implantacao': typeof AppWorkspaceIdImplantacaoRoute
  '/app/$workspaceId/integracoes': typeof AppWorkspaceIdIntegracoesRoute
  '/app/$workspaceId/leads': typeof AppWorkspaceIdLeadsRoute
  '/app/$workspaceId/membros': typeof AppWorkspaceIdMembrosRoute
  '/app/$workspaceId/notificacoes': typeof AppWorkspaceIdNotificacoesRoute
  '/app/$workspaceId/paginas-e-pixels': typeof AppWorkspaceIdPaginasEPixelsRoute
  '/app/$workspaceId/publicos': typeof AppWorkspaceIdPublicosRoute
  '/app/$workspaceId/regras': typeof AppWorkspaceIdRegrasRoute
  '/app/$workspaceId/relatorios': typeof AppWorkspaceIdRelatoriosRoute
  '/cobranca/simulado/$sessionId': typeof CobrancaSimuladoSessionIdRoute
  '/app/$workspaceId': typeof AppWorkspaceIdIndexRoute
  '/app/$workspaceId/assistente/$draftId': typeof AppWorkspaceIdAssistenteDraftIdRoute
  '/app/$workspaceId/business-managers/$businessId': typeof AppWorkspaceIdBusinessManagersBusinessIdRoute
  '/app/$workspaceId/implantacao/$implantationId': typeof AppWorkspaceIdImplantacaoImplantationIdRoute
  '/app/$workspaceId/regras/$ruleId': typeof AppWorkspaceIdRegrasRuleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/cadastro': typeof CadastroRoute
  '/entrar': typeof EntrarRoute
  '/exclusao-de-dados': typeof ExclusaoDeDadosRoute
  '/privacidade': typeof PrivacidadeRoute
  '/termos': typeof TermosRoute
  '/admin/cupons': typeof AdminCuponsRoute
  '/admin/planos': typeof AdminPlanosRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/app/$workspaceId': typeof AppWorkspaceIdRouteWithChildren
  '/app/conta': typeof AppContaRoute
  '/app/novo-workspace': typeof AppNovoWorkspaceRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/relatorio/$token': typeof RelatorioTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/workspaces_/$id': typeof AdminWorkspacesIdRoute
  '/app/$workspaceId/assistente': typeof AppWorkspaceIdAssistenteRoute
  '/app/$workspaceId/auditoria': typeof AppWorkspaceIdAuditoriaRoute
  '/app/$workspaceId/business-managers': typeof AppWorkspaceIdBusinessManagersRoute
  '/app/$workspaceId/campanhas': typeof AppWorkspaceIdCampanhasRoute
  '/app/$workspaceId/clientes': typeof AppWorkspaceIdClientesRoute
  '/app/$workspaceId/cobranca': typeof AppWorkspaceIdCobrancaRoute
  '/app/$workspaceId/configuracoes': typeof AppWorkspaceIdConfiguracoesRoute
  '/app/$workspaceId/contas-de-anuncio': typeof AppWorkspaceIdContasDeAnuncioRoute
  '/app/$workspaceId/criativos': typeof AppWorkspaceIdCriativosRoute
  '/app/$workspaceId/ia': typeof AppWorkspaceIdIaRoute
  '/app/$workspaceId/implantacao': typeof AppWorkspaceIdImplantacaoRoute
  '/app/$workspaceId/integracoes': typeof AppWorkspaceIdIntegracoesRoute
  '/app/$workspaceId/leads': typeof AppWorkspaceIdLeadsRoute
  '/app/$workspaceId/membros': typeof AppWorkspaceIdMembrosRoute
  '/app/$workspaceId/notificacoes': typeof AppWorkspaceIdNotificacoesRoute
  '/app/$workspaceId/paginas-e-pixels': typeof AppWorkspaceIdPaginasEPixelsRoute
  '/app/$workspaceId/publicos': typeof AppWorkspaceIdPublicosRoute
  '/app/$workspaceId/regras': typeof AppWorkspaceIdRegrasRoute
  '/app/$workspaceId/relatorios': typeof AppWorkspaceIdRelatoriosRoute
  '/cobranca/simulado/$sessionId': typeof CobrancaSimuladoSessionIdRoute
  '/app/$workspaceId/': typeof AppWorkspaceIdIndexRoute
  '/app/$workspaceId/assistente_/$draftId': typeof AppWorkspaceIdAssistenteDraftIdRoute
  '/app/$workspaceId/business-managers_/$businessId': typeof AppWorkspaceIdBusinessManagersBusinessIdRoute
  '/app/$workspaceId/implantacao_/$implantationId': typeof AppWorkspaceIdImplantacaoImplantationIdRoute
  '/app/$workspaceId/regras_/$ruleId': typeof AppWorkspaceIdRegrasRuleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/cadastro'
    | '/entrar'
    | '/exclusao-de-dados'
    | '/privacidade'
    | '/termos'
    | '/admin/cupons'
    | '/admin/planos'
    | '/admin/workspaces'
    | '/app/$workspaceId'
    | '/app/conta'
    | '/app/novo-workspace'
    | '/convite/$token'
    | '/relatorio/$token'
    | '/admin/'
    | '/app/'
    | '/admin/workspaces/$id'
    | '/app/$workspaceId/assistente'
    | '/app/$workspaceId/auditoria'
    | '/app/$workspaceId/business-managers'
    | '/app/$workspaceId/campanhas'
    | '/app/$workspaceId/clientes'
    | '/app/$workspaceId/cobranca'
    | '/app/$workspaceId/configuracoes'
    | '/app/$workspaceId/contas-de-anuncio'
    | '/app/$workspaceId/criativos'
    | '/app/$workspaceId/ia'
    | '/app/$workspaceId/implantacao'
    | '/app/$workspaceId/integracoes'
    | '/app/$workspaceId/leads'
    | '/app/$workspaceId/membros'
    | '/app/$workspaceId/notificacoes'
    | '/app/$workspaceId/paginas-e-pixels'
    | '/app/$workspaceId/publicos'
    | '/app/$workspaceId/regras'
    | '/app/$workspaceId/relatorios'
    | '/cobranca/simulado/$sessionId'
    | '/app/$workspaceId/'
    | '/app/$workspaceId/assistente/$draftId'
    | '/app/$workspaceId/business-managers/$businessId'
    | '/app/$workspaceId/implantacao/$implantationId'
    | '/app/$workspaceId/regras/$ruleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cadastro'
    | '/entrar'
    | '/exclusao-de-dados'
    | '/privacidade'
    | '/termos'
    | '/admin/cupons'
    | '/admin/planos'
    | '/admin/workspaces'
    | '/app/conta'
    | '/app/novo-workspace'
    | '/convite/$token'
    | '/relatorio/$token'
    | '/admin'
    | '/app'
    | '/admin/workspaces/$id'
    | '/app/$workspaceId/assistente'
    | '/app/$workspaceId/auditoria'
    | '/app/$workspaceId/business-managers'
    | '/app/$workspaceId/campanhas'
    | '/app/$workspaceId/clientes'
    | '/app/$workspaceId/cobranca'
    | '/app/$workspaceId/configuracoes'
    | '/app/$workspaceId/contas-de-anuncio'
    | '/app/$workspaceId/criativos'
    | '/app/$workspaceId/ia'
    | '/app/$workspaceId/implantacao'
    | '/app/$workspaceId/integracoes'
    | '/app/$workspaceId/leads'
    | '/app/$workspaceId/membros'
    | '/app/$workspaceId/notificacoes'
    | '/app/$workspaceId/paginas-e-pixels'
    | '/app/$workspaceId/publicos'
    | '/app/$workspaceId/regras'
    | '/app/$workspaceId/relatorios'
    | '/cobranca/simulado/$sessionId'
    | '/app/$workspaceId'
    | '/app/$workspaceId/assistente/$draftId'
    | '/app/$workspaceId/business-managers/$businessId'
    | '/app/$workspaceId/implantacao/$implantationId'
    | '/app/$workspaceId/regras/$ruleId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/cadastro'
    | '/entrar'
    | '/exclusao-de-dados'
    | '/privacidade'
    | '/termos'
    | '/admin/cupons'
    | '/admin/planos'
    | '/admin/workspaces'
    | '/app/$workspaceId'
    | '/app/conta'
    | '/app/novo-workspace'
    | '/convite/$token'
    | '/relatorio/$token'
    | '/admin/'
    | '/app/'
    | '/admin/workspaces_/$id'
    | '/app/$workspaceId/assistente'
    | '/app/$workspaceId/auditoria'
    | '/app/$workspaceId/business-managers'
    | '/app/$workspaceId/campanhas'
    | '/app/$workspaceId/clientes'
    | '/app/$workspaceId/cobranca'
    | '/app/$workspaceId/configuracoes'
    | '/app/$workspaceId/contas-de-anuncio'
    | '/app/$workspaceId/criativos'
    | '/app/$workspaceId/ia'
    | '/app/$workspaceId/implantacao'
    | '/app/$workspaceId/integracoes'
    | '/app/$workspaceId/leads'
    | '/app/$workspaceId/membros'
    | '/app/$workspaceId/notificacoes'
    | '/app/$workspaceId/paginas-e-pixels'
    | '/app/$workspaceId/publicos'
    | '/app/$workspaceId/regras'
    | '/app/$workspaceId/relatorios'
    | '/cobranca/simulado/$sessionId'
    | '/app/$workspaceId/'
    | '/app/$workspaceId/assistente_/$draftId'
    | '/app/$workspaceId/business-managers_/$businessId'
    | '/app/$workspaceId/implantacao_/$implantationId'
    | '/app/$workspaceId/regras_/$ruleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  CadastroRoute: typeof CadastroRoute
  EntrarRoute: typeof EntrarRoute
  ExclusaoDeDadosRoute: typeof ExclusaoDeDadosRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  TermosRoute: typeof TermosRoute
  ConviteTokenRoute: typeof ConviteTokenRoute
  RelatorioTokenRoute: typeof RelatorioTokenRoute
  CobrancaSimuladoSessionIdRoute: typeof CobrancaSimuladoSessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cadastro': {
      id: '/cadastro'
      path: '/cadastro'
      fullPath: '/cadastro'
      preLoaderRoute: typeof CadastroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exclusao-de-dados': {
      id: '/exclusao-de-dados'
      path: '/exclusao-de-dados'
      fullPath: '/exclusao-de-dados'
      preLoaderRoute: typeof ExclusaoDeDadosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cupons': {
      id: '/admin/cupons'
      path: '/cupons'
      fullPath: '/admin/cupons'
      preLoaderRoute: typeof AdminCuponsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/planos': {
      id: '/admin/planos'
      path: '/planos'
      fullPath: '/admin/planos'
      preLoaderRoute: typeof AdminPlanosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/workspaces': {
      id: '/admin/workspaces'
      path: '/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AdminWorkspacesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/$workspaceId': {
      id: '/app/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/app/$workspaceId'
      preLoaderRoute: typeof AppWorkspaceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/conta': {
      id: '/app/conta'
      path: '/conta'
      fullPath: '/app/conta'
      preLoaderRoute: typeof AppContaRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/novo-workspace': {
      id: '/app/novo-workspace'
      path: '/novo-workspace'
      fullPath: '/app/novo-workspace'
      preLoaderRoute: typeof AppNovoWorkspaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/convite/$token': {
      id: '/convite/$token'
      path: '/convite/$token'
      fullPath: '/convite/$token'
      preLoaderRoute: typeof ConviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relatorio/$token': {
      id: '/relatorio/$token'
      path: '/relatorio/$token'
      fullPath: '/relatorio/$token'
      preLoaderRoute: typeof RelatorioTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/workspaces_/$id': {
      id: '/admin/workspaces_/$id'
      path: '/workspaces/$id'
      fullPath: '/admin/workspaces/$id'
      preLoaderRoute: typeof AdminWorkspacesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/$workspaceId/': {
      id: '/app/$workspaceId/'
      path: '/'
      fullPath: '/app/$workspaceId/'
      preLoaderRoute: typeof AppWorkspaceIdIndexRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/assistente': {
      id: '/app/$workspaceId/assistente'
      path: '/assistente'
      fullPath: '/app/$workspaceId/assistente'
      preLoaderRoute: typeof AppWorkspaceIdAssistenteRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/auditoria': {
      id: '/app/$workspaceId/auditoria'
      path: '/auditoria'
      fullPath: '/app/$workspaceId/auditoria'
      preLoaderRoute: typeof AppWorkspaceIdAuditoriaRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/business-managers': {
      id: '/app/$workspaceId/business-managers'
      path: '/business-managers'
      fullPath: '/app/$workspaceId/business-managers'
      preLoaderRoute: typeof AppWorkspaceIdBusinessManagersRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/campanhas': {
      id: '/app/$workspaceId/campanhas'
      path: '/campanhas'
      fullPath: '/app/$workspaceId/campanhas'
      preLoaderRoute: typeof AppWorkspaceIdCampanhasRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/clientes': {
      id: '/app/$workspaceId/clientes'
      path: '/clientes'
      fullPath: '/app/$workspaceId/clientes'
      preLoaderRoute: typeof AppWorkspaceIdClientesRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/cobranca': {
      id: '/app/$workspaceId/cobranca'
      path: '/cobranca'
      fullPath: '/app/$workspaceId/cobranca'
      preLoaderRoute: typeof AppWorkspaceIdCobrancaRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/configuracoes': {
      id: '/app/$workspaceId/configuracoes'
      path: '/configuracoes'
      fullPath: '/app/$workspaceId/configuracoes'
      preLoaderRoute: typeof AppWorkspaceIdConfiguracoesRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/contas-de-anuncio': {
      id: '/app/$workspaceId/contas-de-anuncio'
      path: '/contas-de-anuncio'
      fullPath: '/app/$workspaceId/contas-de-anuncio'
      preLoaderRoute: typeof AppWorkspaceIdContasDeAnuncioRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/criativos': {
      id: '/app/$workspaceId/criativos'
      path: '/criativos'
      fullPath: '/app/$workspaceId/criativos'
      preLoaderRoute: typeof AppWorkspaceIdCriativosRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/ia': {
      id: '/app/$workspaceId/ia'
      path: '/ia'
      fullPath: '/app/$workspaceId/ia'
      preLoaderRoute: typeof AppWorkspaceIdIaRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/implantacao': {
      id: '/app/$workspaceId/implantacao'
      path: '/implantacao'
      fullPath: '/app/$workspaceId/implantacao'
      preLoaderRoute: typeof AppWorkspaceIdImplantacaoRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/integracoes': {
      id: '/app/$workspaceId/integracoes'
      path: '/integracoes'
      fullPath: '/app/$workspaceId/integracoes'
      preLoaderRoute: typeof AppWorkspaceIdIntegracoesRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/leads': {
      id: '/app/$workspaceId/leads'
      path: '/leads'
      fullPath: '/app/$workspaceId/leads'
      preLoaderRoute: typeof AppWorkspaceIdLeadsRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/membros': {
      id: '/app/$workspaceId/membros'
      path: '/membros'
      fullPath: '/app/$workspaceId/membros'
      preLoaderRoute: typeof AppWorkspaceIdMembrosRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/notificacoes': {
      id: '/app/$workspaceId/notificacoes'
      path: '/notificacoes'
      fullPath: '/app/$workspaceId/notificacoes'
      preLoaderRoute: typeof AppWorkspaceIdNotificacoesRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/paginas-e-pixels': {
      id: '/app/$workspaceId/paginas-e-pixels'
      path: '/paginas-e-pixels'
      fullPath: '/app/$workspaceId/paginas-e-pixels'
      preLoaderRoute: typeof AppWorkspaceIdPaginasEPixelsRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/publicos': {
      id: '/app/$workspaceId/publicos'
      path: '/publicos'
      fullPath: '/app/$workspaceId/publicos'
      preLoaderRoute: typeof AppWorkspaceIdPublicosRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/regras': {
      id: '/app/$workspaceId/regras'
      path: '/regras'
      fullPath: '/app/$workspaceId/regras'
      preLoaderRoute: typeof AppWorkspaceIdRegrasRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/relatorios': {
      id: '/app/$workspaceId/relatorios'
      path: '/relatorios'
      fullPath: '/app/$workspaceId/relatorios'
      preLoaderRoute: typeof AppWorkspaceIdRelatoriosRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/cobranca/simulado/$sessionId': {
      id: '/cobranca/simulado/$sessionId'
      path: '/cobranca/simulado/$sessionId'
      fullPath: '/cobranca/simulado/$sessionId'
      preLoaderRoute: typeof CobrancaSimuladoSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/$workspaceId/assistente_/$draftId': {
      id: '/app/$workspaceId/assistente_/$draftId'
      path: '/assistente/$draftId'
      fullPath: '/app/$workspaceId/assistente/$draftId'
      preLoaderRoute: typeof AppWorkspaceIdAssistenteDraftIdRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/business-managers_/$businessId': {
      id: '/app/$workspaceId/business-managers_/$businessId'
      path: '/business-managers/$businessId'
      fullPath: '/app/$workspaceId/business-managers/$businessId'
      preLoaderRoute: typeof AppWorkspaceIdBusinessManagersBusinessIdRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/implantacao_/$implantationId': {
      id: '/app/$workspaceId/implantacao_/$implantationId'
      path: '/implantacao/$implantationId'
      fullPath: '/app/$workspaceId/implantacao/$implantationId'
      preLoaderRoute: typeof AppWorkspaceIdImplantacaoImplantationIdRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
    '/app/$workspaceId/regras_/$ruleId': {
      id: '/app/$workspaceId/regras_/$ruleId'
      path: '/regras/$ruleId'
      fullPath: '/app/$workspaceId/regras/$ruleId'
      preLoaderRoute: typeof AppWorkspaceIdRegrasRuleIdRouteImport
      parentRoute: typeof AppWorkspaceIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminCuponsRoute: typeof AdminCuponsRoute
  AdminPlanosRoute: typeof AdminPlanosRoute
  AdminWorkspacesRoute: typeof AdminWorkspacesRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminWorkspacesIdRoute: typeof AdminWorkspacesIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCuponsRoute: AdminCuponsRoute,
  AdminPlanosRoute: AdminPlanosRoute,
  AdminWorkspacesRoute: AdminWorkspacesRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminWorkspacesIdRoute: AdminWorkspacesIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppWorkspaceIdRouteChildren {
  AppWorkspaceIdAssistenteRoute: typeof AppWorkspaceIdAssistenteRoute
  AppWorkspaceIdAuditoriaRoute: typeof AppWorkspaceIdAuditoriaRoute
  AppWorkspaceIdBusinessManagersRoute: typeof AppWorkspaceIdBusinessManagersRoute
  AppWorkspaceIdCampanhasRoute: typeof AppWorkspaceIdCampanhasRoute
  AppWorkspaceIdClientesRoute: typeof AppWorkspaceIdClientesRoute
  AppWorkspaceIdCobrancaRoute: typeof AppWorkspaceIdCobrancaRoute
  AppWorkspaceIdConfiguracoesRoute: typeof AppWorkspaceIdConfiguracoesRoute
  AppWorkspaceIdContasDeAnuncioRoute: typeof AppWorkspaceIdContasDeAnuncioRoute
  AppWorkspaceIdCriativosRoute: typeof AppWorkspaceIdCriativosRoute
  AppWorkspaceIdIaRoute: typeof AppWorkspaceIdIaRoute
  AppWorkspaceIdImplantacaoRoute: typeof AppWorkspaceIdImplantacaoRoute
  AppWorkspaceIdIntegracoesRoute: typeof AppWorkspaceIdIntegracoesRoute
  AppWorkspaceIdLeadsRoute: typeof AppWorkspaceIdLeadsRoute
  AppWorkspaceIdMembrosRoute: typeof AppWorkspaceIdMembrosRoute
  AppWorkspaceIdNotificacoesRoute: typeof AppWorkspaceIdNotificacoesRoute
  AppWorkspaceIdPaginasEPixelsRoute: typeof AppWorkspaceIdPaginasEPixelsRoute
  AppWorkspaceIdPublicosRoute: typeof AppWorkspaceIdPublicosRoute
  AppWorkspaceIdRegrasRoute: typeof AppWorkspaceIdRegrasRoute
  AppWorkspaceIdRelatoriosRoute: typeof AppWorkspaceIdRelatoriosRoute
  AppWorkspaceIdIndexRoute: typeof AppWorkspaceIdIndexRoute
  AppWorkspaceIdAssistenteDraftIdRoute: typeof AppWorkspaceIdAssistenteDraftIdRoute
  AppWorkspaceIdBusinessManagersBusinessIdRoute: typeof AppWorkspaceIdBusinessManagersBusinessIdRoute
  AppWorkspaceIdImplantacaoImplantationIdRoute: typeof AppWorkspaceIdImplantacaoImplantationIdRoute
  AppWorkspaceIdRegrasRuleIdRoute: typeof AppWorkspaceIdRegrasRuleIdRoute
}

const AppWorkspaceIdRouteChildren: AppWorkspaceIdRouteChildren = {
  AppWorkspaceIdAssistenteRoute: AppWorkspaceIdAssistenteRoute,
  AppWorkspaceIdAuditoriaRoute: AppWorkspaceIdAuditoriaRoute,
  AppWorkspaceIdBusinessManagersRoute: AppWorkspaceIdBusinessManagersRoute,
  AppWorkspaceIdCampanhasRoute: AppWorkspaceIdCampanhasRoute,
  AppWorkspaceIdClientesRoute: AppWorkspaceIdClientesRoute,
  AppWorkspaceIdCobrancaRoute: AppWorkspaceIdCobrancaRoute,
  AppWorkspaceIdConfiguracoesRoute: AppWorkspaceIdConfiguracoesRoute,
  AppWorkspaceIdContasDeAnuncioRoute: AppWorkspaceIdContasDeAnuncioRoute,
  AppWorkspaceIdCriativosRoute: AppWorkspaceIdCriativosRoute,
  AppWorkspaceIdIaRoute: AppWorkspaceIdIaRoute,
  AppWorkspaceIdImplantacaoRoute: AppWorkspaceIdImplantacaoRoute,
  AppWorkspaceIdIntegracoesRoute: AppWorkspaceIdIntegracoesRoute,
  AppWorkspaceIdLeadsRoute: AppWorkspaceIdLeadsRoute,
  AppWorkspaceIdMembrosRoute: AppWorkspaceIdMembrosRoute,
  AppWorkspaceIdNotificacoesRoute: AppWorkspaceIdNotificacoesRoute,
  AppWorkspaceIdPaginasEPixelsRoute: AppWorkspaceIdPaginasEPixelsRoute,
  AppWorkspaceIdPublicosRoute: AppWorkspaceIdPublicosRoute,
  AppWorkspaceIdRegrasRoute: AppWorkspaceIdRegrasRoute,
  AppWorkspaceIdRelatoriosRoute: AppWorkspaceIdRelatoriosRoute,
  AppWorkspaceIdIndexRoute: AppWorkspaceIdIndexRoute,
  AppWorkspaceIdAssistenteDraftIdRoute: AppWorkspaceIdAssistenteDraftIdRoute,
  AppWorkspaceIdBusinessManagersBusinessIdRoute:
    AppWorkspaceIdBusinessManagersBusinessIdRoute,
  AppWorkspaceIdImplantacaoImplantationIdRoute:
    AppWorkspaceIdImplantacaoImplantationIdRoute,
  AppWorkspaceIdRegrasRuleIdRoute: AppWorkspaceIdRegrasRuleIdRoute,
}

const AppWorkspaceIdRouteWithChildren = AppWorkspaceIdRoute._addFileChildren(
  AppWorkspaceIdRouteChildren,
)

interface AppRouteChildren {
  AppWorkspaceIdRoute: typeof AppWorkspaceIdRouteWithChildren
  AppContaRoute: typeof AppContaRoute
  AppNovoWorkspaceRoute: typeof AppNovoWorkspaceRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppWorkspaceIdRoute: AppWorkspaceIdRouteWithChildren,
  AppContaRoute: AppContaRoute,
  AppNovoWorkspaceRoute: AppNovoWorkspaceRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  CadastroRoute: CadastroRoute,
  EntrarRoute: EntrarRoute,
  ExclusaoDeDadosRoute: ExclusaoDeDadosRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  TermosRoute: TermosRoute,
  ConviteTokenRoute: ConviteTokenRoute,
  RelatorioTokenRoute: RelatorioTokenRoute,
  CobrancaSimuladoSessionIdRoute: CobrancaSimuladoSessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
